<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="anno_inizio">Anno inizio</label>
          <input type="text" class="form-control" id="anno_inizio"
                 name="anno_inizio"
                 v-model="description.anno_inizio" :disabled="disabled">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="anno_fine">Anno fine</label>
          <input type="text" class="form-control" id="anno_fine"
                 name="anno_fine"
                 v-model="description.anno_fine" :disabled="disabled">
        </div>
      </div>
    </div>

    <div class="row" v-if="!reelDescription">
      <div class="col-md-12">
        <div class="form-group">
          <label for="suono">Suono</label>
          <select v-model="description.suono" class="form-control"
                  id="suono"
                  name="suono" :disabled="disabled">
            <option></option>
            <option v-for="(suono, id) in suoni"
                    v-bind:value="id">
              {{ suono }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row" v-if="reelDescription">
      <div class="col-md-12">
        <div class="form-group">
          <label for="suono">Suono</label>
          <select v-model="description.suono" class="form-control"
                  id="reel-suono"
                  name="suono" :disabled="true">
            <option></option>
            <option v-for="(suono, id) in ynp"
                    v-bind:value="id">
              {{ suono }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="cromatismo">Cromatismo</label>
          <select v-model="description.cromatismo" class="form-control"
                  id="cromatismo"
                  name="cromatismo" :disabled="disabled">
            <option></option>
            <option v-for="(cromatismo, id) in cromatismi"
                    v-bind:value="id">
              {{ cromatismo }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Tipologia</label>
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="description.tipo_famiglia" :disabled="disabled">
              Famiglia
            </label>
          </div>

          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="description.tipo_amatoriale" :disabled="disabled">
              Amatoriale
            </label>
          </div>

          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="description.tipo_edizione" :disabled="disabled">
              Di edizione
            </label>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="filmPersons">Persone</label>
          <multiselect
            v-model="description.filmPersons.data"
            :options="persons"
            :multiple="true"
            track-by="id"
            label="nome"
            placeholder="seleziona"
            SelectLabel="seleziona"
            SelectedLabel="selezionato"
            DeselectLabel="deseleziona"
            id="filmPersons"
            name="filmPersons"
            :disabled="disabled"
            :clear-on-select="false"
            :searchable="true"
            @search-change="personsFind">
          </multiselect>

        </div>
      </div>
    </div>

    <!--        <div class="row">-->
    <!--            <div class="col-md-12">-->
    <!--                <div class="form-group">-->
    <!--                    <label for="keywords">Keywords</label>-->
    <!--                    <multiselect-->
    <!--                            v-model="description.keywords.data"-->
    <!--                            :options="keywords"-->
    <!--                            :multiple="true"-->
    <!--                            track-by="id"-->
    <!--                            label="keyword"-->
    <!--                            placeholder="seleziona"-->
    <!--                            SelectLabel="seleziona"-->
    <!--                            SelectedLabel="selezionato"-->
    <!--                            DeselectLabel="deseleziona"-->
    <!--                            id="keywords"-->
    <!--                            name="keywords"-->
    <!--                            :disabled="disabled"-->
    <!--                            :clear-on-select="false"-->
    <!--                            :searchable="true"-->
    <!--                            @search-change="keywordsFind">-->
    <!--                    </multiselect>-->

    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="macrotags">Macrotags</label>
          <multiselect
            v-model="description.macrotags.data"
            :options="macrotags"
            :multiple="true"
            track-by="id"
            label="macrotag"
            placeholder="seleziona"
            SelectLabel="seleziona"
            SelectedLabel="selezionato"
            DeselectLabel="deseleziona"
            id="macrotags"
            name="macrotags"
            :disabled="disabled"
            :clear-on-select="false"
            :searchable="true"
            @search-change="macrotagsFind">
          </multiselect>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="microtags">Microtags</label>
          <multiselect
            v-model="description.microtags.data"
            :options="microtags"
            :multiple="true"
            track-by="id"
            label="microtag"
            placeholder="seleziona"
            SelectLabel="seleziona"
            SelectedLabel="selezionato"
            DeselectLabel="deseleziona"
            id="microtags"
            name="microtags"
            :disabled="disabled"
            :clear-on-select="false"
            :searchable="true"
            @search-change="microtagsFind">
          </multiselect>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="places">Luoghi</label>
          <multiselect
            v-model="description.places.data"
            :options="places"
            :multiple="true"
            track-by="id"
            label="nome"
            placeholder="seleziona"
            SelectLabel="seleziona"
            SelectedLabel="selezionato"
            DeselectLabel="deseleziona"
            id="places"
            name="places"
            :disabled="disabled"
            :clear-on-select="false"
            :searchable="true"
            @search-change="placesFind">
          </multiselect>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import macrotagsApi from '../../api/macrotags'
  import microtagsApi from '../../api/microtags'
  import placesApi from '../../api/places'

  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import personsApi from '../../api/persons'

  export default {
    props: ['description', 'disabled', 'reelDescription'],
    data () {
      return {
        persons: [],
        places: [],
        // keywords: [],
        macrotags: [],
        microtags: []
      }
    },
    methods: {
      personsFind (query) {
        personsApi.select(query)
          .then((response) => {
            this.persons = response.data.data
          })
      },
      placesFind (query) {
        placesApi.select(query)
          .then((response) => {
            this.places = response.data.data
          })
      },
      // keywordsFind (query) {
      //   keywordsApi.select(query)
      //     .then((response) => {
      //       this.keywords = response.data.data
      //     })
      // },
      macrotagsFind (query) {
        macrotagsApi.select(query)
          .then((response) => {
            this.macrotags = response.data.data
          })
      },
      microtagsFind (query) {
        microtagsApi.select(query)
          .then((response) => {
            this.microtags = response.data.data
          })
      }
    },
    computed: {
      suoni () {
        return this.$store.state.decoder.decoders['_dSound']
      },
      cromatismi () {
        return this.$store.state.decoder.decoders['_dColor']
      },
      ynp () {
        return this.$store.state.decoder.decoders['_dYesNoPartial']
      }
    },
    components: {
      Multiselect
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/components/Description.vue